import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../users/AbilityContext';
import { ActionType } from '../../users/ability.types';

const useUserContextGroupAbility = () => {
  const { isBrand, state } = useApplicationContext();
  const ability = useAbility();

  return (action: ActionType) =>
    isBrand && (!!state.isAdminTeceo || ability.can(action, 'user-context-groups'));
};

export default useUserContextGroupAbility;
